import { FunctionComponent, useEffect } from 'react';

import { NetQuestFavIcons } from '../../assets/netquest/favicons';
import { SightXFavIcons } from '../../assets/favicons';
import { isNetquestClient, isPureProfileClient } from '../../utils/platform';
import { PureProfileFavIcons } from '../../assets/pureprofile/favicons';

interface IFavIconInfo {
  rel: string;
  href: string;
  sizes?: string;
}

const addFavIcon = (favIconInfo: IFavIconInfo, prefix: string) => {
  const link = document.createElement('link');
  link.href = `/${prefix}/${favIconInfo.href}`;
  link.rel = favIconInfo.rel;
  if (favIconInfo.sizes) {
    link.setAttribute('sizes', favIconInfo.sizes);
  }
  document.getElementsByTagName('head')[0].appendChild(link);
};
export const FavIcon: FunctionComponent = () => {
  useEffect(() => {
    if (isPureProfileClient()) {
      PureProfileFavIcons.forEach((info) => addFavIcon(info, 'pureprofileFavicons'));
      return;
    }
    if (isNetquestClient()) {
      NetQuestFavIcons.forEach((info) => addFavIcon(info, 'netquestFavicons'));
      return;
    }
    SightXFavIcons.forEach((info) => addFavIcon(info, 'sightXFavicons'));
  }, []);
  return null;
};
